import {useQuery} from 'react-query';

import useFetch from '~api/useFetch';
import {ApiEndpoints} from '~constants/api';
import {PlotProofResponse} from '~types/Plots';

export default function useFetchPlotProof(id?: number) {
    const {apiGet} = useFetch();

    return useQuery<PlotProofResponse>(
        [ApiEndpoints.PlotProof, id],
        () =>
            apiGet(ApiEndpoints.PlotProof, {
                bindParams: {id},
            }),
        {enabled: Boolean(id)},
    );
}
